import React from 'react';
import classes from './SupportFiles.module.css';
import { SupportFileCard } from './SupportFileCard';
import { SupportItemType } from '../../../screens/Support/Support';

import { formatSize } from '../../../utils/miscUtils';
import Spinner from '../../UI/Spinner/Spinner';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  data: SupportItemType[];
};

const SupportFiles: React.FC<Props> = ({ data }) => {
  const { translations } = useTranslation();
  const [selectedFile, setSelectedFile] = React.useState<SupportItemType>();
  const [fileUrl, setFileUrl] = React.useState<string>();
  const [isDownloading, setIsDownloading] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (data.length > 0) {
      setSelectedFile(data[0]);
    }
  }, [data]);

  React.useEffect(() => {
    const downloadPdf = async (file: SupportItemType) => {
      setIsDownloading(true);
      const response = await fetch(`${file.File.data.attributes.url}`);
      const blob = await response.blob();
      const pdfBlobUrl = URL.createObjectURL(blob);
      setFileUrl(pdfBlobUrl);
      setIsDownloading(false);
    };

    if (selectedFile && selectedFile?.File?.data?.attributes?.mime === 'application/pdf') {
      downloadPdf(selectedFile);
    }
  }, [selectedFile]);

  return (
    <div className={classes.container}>
      <div className={classes.cardsContainer}>
        {data
          .sort((a, b) => parseInt(a.Position) - parseInt(b.Position))
          .map((item, index) => (
            <SupportFileCard
              key={index}
              item={item}
              selectedFile={selectedFile}
              handleFileSelect={() => setSelectedFile(item)}
            />
          ))}
      </div>
      {selectedFile && (
        <div className={classes.largeVideoContainer}>
          <div className={classes.largeVideoHeader}>
            <div className={classes.stepNumber}>{selectedFile.Position}</div>
            {selectedFile.Title}
            {selectedFile.File.data.attributes.mime === 'application/pdf' ? (
              <div className={classes.videoLength}>
                {formatSize(selectedFile.File.data.attributes.size)}
              </div>
            ) : (
              <div className={classes.videoLength}>
                {selectedFile.VideoLength} {translations('seconds')}
              </div>
            )}
            {!isDownloading && selectedFile.File.data.attributes.mime === 'application/pdf' && (
              <div
                onClick={() => window.open(fileUrl)}
                style={{ marginLeft: 'auto', cursor: 'pointer' }}
              >
                {translations('download')}
              </div>
            )}
          </div>
          <div className={classes.videoBackground}>
            {(selectedFile.File.data.attributes.mime === 'video/mp4' ||
              selectedFile.File.data.attributes.mime === 'video/webm') && (
              <video src={`${selectedFile.File.data.attributes.url}`} controls width={'85%'} />
            )}
            {selectedFile.File.data.attributes.mime === 'application/pdf' &&
              (isDownloading ? (
                <Spinner />
              ) : (
                <div className={classes.iframeContainer}>
                  <iframe className={classes.iframe} title={'document-preview'} src={fileUrl} />
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export { SupportFiles };
